import { render, staticRenderFns } from "./templ.vue?vue&type=template&id=4a6194ba&scoped=true&lang=html"
import script from "./templ.vue?vue&type=script&lang=js"
export * from "./templ.vue?vue&type=script&lang=js"
import style0 from "./templ.vue?vue&type=style&index=0&id=4a6194ba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a6194ba",
  null
  
)

export default component.exports